export default "__VITE_ASSET__BEipyf58__"